import { ROUTE_PATH } from "../../app/constants";
import { Header, NavigationLinkButton } from "../../components/RegularComponents";

const PDF_LINK = "https://novascotia.ca/changes-mortgage-industry-regulation/docs/MRA-regulatory-information-program.pdf"

export const MraRegulatoryInformationNotDone = () => {

    return (
        <>
        <div className="container">
            <div className="row bottomMarginMedium">
                <div className="col-lg-8">
                    <Header 
                        id="regulatory-inforation-not-done-header"
                        header={"Complete the regulatory information program before you start"}
                    />
                </div>
            </div>

            <div className="row bottomMarginMedium">
                <div className="col-lg-8">
                    <NavigationLinkButton 
                        onClick={() => {
                            window.open(PDF_LINK, '_blank')
                        }}
                        text="Download the PDF and complete the survey"
                    />
                </div>
            </div>

            <div className="row bottomMarginNormal">
                <div className="col-lg-8">
                     <NavigationLinkButton 
                        onClick={() => {
                            window.location.assign(ROUTE_PATH.LAUNCHPAGE_MORTGAGE)
                        }}
                        text="Back to Start"
                    />
                </div>
            </div>
        </div>
        </>
    )
}
